<template>
    <SurveyLoader :surveyId="id" />
</template>

<script>
import SurveyLoader from "@/components/external-components/survey-viewer/SurveyLoader.vue";

export default {
    name: "survey-view",
    components: {
        SurveyLoader,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
};
</script>